import { Component, HostListener, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NotificationsService } from '../../core/services/notifications.service';

/**
 * Renders whatever `NotificationsService` is holding: success toasts, and the modal for a failed
 * write.
 *
 * Hand-rolled rather than `p-toast` / `p-dialog` on purpose. This component is hosted by the app
 * shell, which is in the **initial** bundle, and pulling PrimeNG into it costs every visitor the
 * library's style base whether or not they ever trigger a notification — the same trap the tooltip
 * note in CLAUDE.md records (+49 kB raw for one topbar tooltip). Two elements and some CSS are
 * cheaper than the dependency, and neither piece needs PrimeNG's behavior.
 */
@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent {
  readonly notify = inject(NotificationsService);

  /** Escape closes the error modal, which is what every other dismissible surface here does. */
  @HostListener('document:keydown.escape')
  onEscape() {
    this.notify.dismissError();
  }
}
